import { application } from "./application"
import ButtonBridgeController from "./bridge/button_controller"
import PageLoadBridgeController from "./bridge/page_load_controller"
import VoiceBridgeController from "./bridge/voice_controller"
import NavBarBridgeController from "./bridge/nav_bar_controller"
import ThemeBridgeController from "./bridge/theme_controller"
import BottomNavBridgeController from "./bridge/bottom_nav_controller"
import ExpenseDockBridgeController from "./bridge/expense_dock_controller"
import ExpenseScanBridgeController from "./bridge/expense_scan_controller"
import MenuBridgeController from "./bridge/menu_controller"
import OverflowMenuBridgeController from "./bridge/overflow_menu_controller"
import HapticBridgeController from "./bridge/haptic_controller"
import AppReviewBridgeController from "./bridge/app_review_controller"
import GoogleSignInBridgeController from "./bridge/google_sign_in_controller"
import AppleSignInBridgeController from "./bridge/apple_sign_in_controller"
import PushTokenBridgeController from "./bridge/push_token_controller"
import AppIconBridgeController from "./bridge/app_icon_controller"
import SubscriptionBridgeController from "./bridge/subscription_controller"
import LogoutBridgeController from "./bridge/logout_controller"
import PlaidLinkBridgeController from "./bridge/plaid_link_controller"
import CaptureKeyBridgeController from "./bridge/capture_key_controller"
import DropdownController from "./dropdown_controller"
import ToolAssignController from "./tool_assign_controller"
import ToolPickerController from "./tool_picker_controller"
import PasswordVisibilityController from "./password_visibility_controller"
import VoiceModalController from "./voice_modal_controller"
import ExpenseDeckController from "./expense_deck_controller"
import BudgetCarouselController from "./budget_carousel_controller"
import BudgetBarController from "./budget_bar_controller"
import FlexibleToggleController from "./flexible_toggle_controller"
import BudgetAssignmentController from "./budget_assignment_controller"
import BudgetSplitController from "./budget_split_controller"
import SortableController from "./sortable_controller"
import EmojiPickerController from "./emoji_picker_controller"
import BudgetSkinsController from "./budget_skins_controller"
import HeaderGradientPreviewController from "./header_gradient_preview_controller"
import BudgetSkinPickerController from "./budget_skin_picker_controller"
import GoalFormController from "./goal_form_controller"
import GoalTrailController from "./goal_trail_controller"
import InViewAnimationController from "./in_view_animation_controller"
import ContributionFormController from "./contribution_form_controller"
import SetAsideFormController from "./set_aside_form_controller"
import TakeOutFormController from "./take_out_form_controller"
import ToastManagerController from "./toast_manager_controller"
import NotificationsSkeletonController from "./notifications_skeleton_controller"
import DismissibleController from "./dismissible_controller"
import AccordionController from "./accordion_controller"
import InvestmentsChartController from "./investments_chart_controller"
import CounterController from "./counter_controller"
import ConfirmSheetController from "./confirm_sheet_controller"
import GoalReachedController from "./goal_reached_controller"
import HelpIntroController from "./help_intro_controller"
import SupportThreadController from "./support_thread_controller"
import ReviewPromptController from "./review_prompt_controller"
import SetupProgressController from "./setup_progress_controller"
import SectionDeckController from "./section_deck_controller"
import StripRailController from "./strip_rail_controller"
import LeftoverFillController from "./leftover_fill_controller"
import RenewalsStripController from "./renewals_strip_controller"
import RenewalsDeskController from "./renewals_desk_controller"
import NetWorthCardController from "./net_worth_card_controller"
import CardSwitcherController from "./card_switcher_controller"
import RenewalsSetasideController from "./renewals_setaside_controller"
import GoalChartController from "./goal_chart_controller"
import DashboardLayoutController from "./dashboard_layout_controller"
import WelcomeCelebrationController from "./welcome_celebration_controller"
import TurboCacheController from "./turbo_cache_controller"
import ExpenseEditController from "./expense_edit_controller"
import ExpenseModalController from "./expense_modal_controller"
import FormDirtyController from "./form_dirty_controller"
import AutoSubmitController from "./auto_submit_controller"
import LocaleSelectController from "./locale_select_controller"
import ExpenseFilterController from "./expense_filter_controller"
import RecurringRailController from "./recurring_rail_controller"
import ExpenseSelectController from "./expense_select_controller"
import LoopCapController from "./loop_cap_controller"
import CategoryCustomizerController from "./category_customizer_controller"
import KindGlideController from "./kind_glide_controller"
import OnboardingController from "./onboarding_controller"
import OnboardingAuthController from "./onboarding_auth_controller"
import EmailVerificationStatusController from "./email_verification_status_controller"
import LandingScrollController from "./landing_scroll_controller"
import BillEditorController from "./bill_editor_controller"
import LandingWaysController from "./landing_ways_controller"
import VoiceTypewriterController from "./voice_typewriter_controller"
import GuideTypewriterController from "./guide_typewriter_controller"
import HeroCarouselController from "./hero_carousel_controller"
import ThemeToggleController from "./theme_toggle_controller"
import LandingThemeController from "./landing_theme_controller"
import VoteAnimationController from "./vote_animation_controller"
import FeedbackCardController from "./feedback_card_controller"
import CopyController from "./copy_controller"
import AccessGateController from "./access_gate_controller"
import StreakCountdownController from "./streak_countdown_controller"
import DueDeckController from "./due_deck_controller"
import DueTodayCardController from "./due_today_card_controller"
import StreakCelebrationController from "./streak_celebration_controller"
import StreakFlameController from "./streak_flame_controller"
import StreakUpController from "./streak_up_controller"
import BankReviewStripController from "./bank_review_strip_controller"
import BankReviewDeckController from "./bank_review_deck_controller"
import MatchReviewStripController from "./match_review_strip_controller"
import MatchReviewDeckController from "./match_review_deck_controller"
import StreakFixController from "./streak_fix_controller"
import SwipeActionsController from "./swipe_actions_controller"
import PrefetchController from "./prefetch_controller"
import DevLoginController from "./dev_login_controller"
import TrialFloatersController from "./trial_floaters_controller"
import WebmcpController from "./webmcp_controller"
import BlogTocController from "./blog_toc_controller"
import PushPermissionController from "./push_permission_controller"
import TabsSliderController from "./tabs_slider_controller"
import SpendingPaceController from "./spending_pace_controller"
import ClearCacheController from "./clear_cache_controller"
import SavingsChartController from "./savings_chart_controller"
import ReportsChartController from "./reports_chart_controller"
import MonthRecapController from "./month_recap_controller"
import AppStoreModalController from "./app_store_modal_controller"
import RevealController from "./reveal_controller"
import VersionRevealController from "./version_reveal_controller"
import IntroOnceController from "./intro_once_controller"
import VideoLoaderController from "./video_loader_controller"
import UnreadCountController from "./unread_count_controller"
import StreakCountController from "./streak_count_controller"
import OtpInputController from "./otp_input_controller"
import WelcomeGrowController from "./welcome_grow_controller"
import WebSidebarController from "./web_sidebar_controller"
import WebAddController from "./web_add_controller"
import WebDragScrollController from "./web_drag_scroll_controller"
import WebPageActionsController from "./web_page_actions_controller"
import PlaidRowController from "./plaid_row_controller"
import PlaidSyncAllController from "./plaid_sync_all_controller"
import WhatsNewTunerController from "./whats_new_tuner_controller"
import FeatureTourController from "./feature_tour_controller"
import AboutPageController from "./about_page_controller"


application.register("bridge--button", ButtonBridgeController)
application.register("page-load", PageLoadBridgeController)
application.register("bridge--voice", VoiceBridgeController)
application.register("bridge--nav-bar", NavBarBridgeController)
application.register("bridge--theme", ThemeBridgeController)
application.register("bridge--bottom-nav", BottomNavBridgeController)
application.register("bridge--expense-dock", ExpenseDockBridgeController)
application.register("bridge--expense-scan", ExpenseScanBridgeController)
application.register("bridge--menu", MenuBridgeController)
application.register("goal-trail", GoalTrailController)
application.register("bridge--overflow-menu", OverflowMenuBridgeController)
application.register("bridge--haptic", HapticBridgeController)
application.register("bridge--app-review", AppReviewBridgeController)
application.register("bridge--google-sign-in", GoogleSignInBridgeController)
application.register("bridge--apple-sign-in", AppleSignInBridgeController)
application.register("bridge--push-token", PushTokenBridgeController)
application.register("bridge--app-icon", AppIconBridgeController)
application.register("bridge--subscription", SubscriptionBridgeController)
application.register("bridge--logout", LogoutBridgeController)
application.register("bridge--plaid-link", PlaidLinkBridgeController)
application.register("bridge--capture-key", CaptureKeyBridgeController)
application.register("dropdown", DropdownController)
application.register("tool-assign", ToolAssignController)
application.register("tool-picker", ToolPickerController)
application.register("password-visibility", PasswordVisibilityController)
application.register("voice-modal", VoiceModalController)
application.register("budget-carousel", BudgetCarouselController)
application.register("budget-bar", BudgetBarController)
application.register("flexible-toggle", FlexibleToggleController)
application.register("budget-assignment", BudgetAssignmentController)
application.register("budget-split", BudgetSplitController)
application.register("sortable", SortableController)
application.register("emoji-picker", EmojiPickerController)
application.register("budget-skins", BudgetSkinsController)
application.register("header-gradient-preview", HeaderGradientPreviewController)
application.register("budget-skin-picker", BudgetSkinPickerController)
application.register("goal-form", GoalFormController)
application.register("in-view-animation", InViewAnimationController)
application.register("contribution-form", ContributionFormController)
application.register("set-aside-form", SetAsideFormController)
application.register("take-out-form", TakeOutFormController)
application.register("toast-manager", ToastManagerController)
application.register("notifications-skeleton", NotificationsSkeletonController)
application.register("dismissible", DismissibleController)
application.register("accordion", AccordionController)
application.register("investments-chart", InvestmentsChartController)
application.register("counter", CounterController)
application.register("reveal", RevealController)
application.register("version-reveal", VersionRevealController)
application.register("intro-once", IntroOnceController)
application.register("video-loader", VideoLoaderController)
application.register("confirm-sheet", ConfirmSheetController)
application.register("goal-reached", GoalReachedController)
application.register("help-intro", HelpIntroController)
application.register("support-thread", SupportThreadController)
application.register("turbo-cache", TurboCacheController)
application.register("expense-edit", ExpenseEditController)
application.register("expense-modal", ExpenseModalController)
application.register("form-dirty", FormDirtyController)
application.register("auto-submit", AutoSubmitController)
application.register("locale-select", LocaleSelectController)
application.register("expense-filter", ExpenseFilterController)
application.register("recurring-rail", RecurringRailController)
application.register("expense-select", ExpenseSelectController)
application.register("loop-cap", LoopCapController)
application.register("category-customizer", CategoryCustomizerController)
application.register("kind-glide", KindGlideController)
application.register("onboarding", OnboardingController)
application.register("onboarding-auth", OnboardingAuthController)
application.register("email-verification-status", EmailVerificationStatusController)
application.register("landing-scroll", LandingScrollController)
application.register("bill-editor", BillEditorController)
application.register("landing-ways", LandingWaysController)
application.register("voice-typewriter", VoiceTypewriterController)
application.register("guide-typewriter", GuideTypewriterController)
application.register("hero-carousel", HeroCarouselController)
application.register("theme-toggle", ThemeToggleController)
application.register("landing-theme", LandingThemeController)
application.register("vote-animation", VoteAnimationController)
application.register("feedback-card", FeedbackCardController)
application.register("copy", CopyController)
application.register("access-gate", AccessGateController)
application.register("streak-countdown", StreakCountdownController)
application.register("due-deck", DueDeckController)
application.register("due-today-card", DueTodayCardController)
application.register("streak-celebration", StreakCelebrationController)
application.register("streak-flame", StreakFlameController)
application.register("streak-up", StreakUpController)
application.register("bank-review-strip", BankReviewStripController)
application.register("bank-review-deck", BankReviewDeckController)
application.register("match-review-strip", MatchReviewStripController)
application.register("match-review-deck", MatchReviewDeckController)
application.register("streak-fix", StreakFixController)
application.register("swipe-actions", SwipeActionsController)
application.register("prefetch", PrefetchController)
application.register("dev-login", DevLoginController)
application.register("trial-floaters", TrialFloatersController)
application.register("webmcp", WebmcpController)
application.register("blog-toc", BlogTocController)
application.register("push-permission", PushPermissionController)
application.register("tabs-slider", TabsSliderController)
application.register("spending-pace", SpendingPaceController)
application.register("clear-cache", ClearCacheController)
application.register("savings-chart", SavingsChartController)
application.register("reports-chart", ReportsChartController)
application.register("month-recap", MonthRecapController)
application.register("app-store-modal", AppStoreModalController)
application.register("unread-count", UnreadCountController)
application.register("streak-count", StreakCountController)
application.register("otp-input", OtpInputController)
application.register("review-prompt", ReviewPromptController)
application.register("setup-progress", SetupProgressController)
application.register("section-deck", SectionDeckController)
application.register("strip-rail", StripRailController)
application.register("leftover-fill", LeftoverFillController)
application.register("renewals-strip", RenewalsStripController)
application.register("renewals-desk", RenewalsDeskController)
application.register("net-worth-card", NetWorthCardController)
application.register("card-switcher", CardSwitcherController)
application.register("renewals-setaside", RenewalsSetasideController)
application.register("goal-chart", GoalChartController)
application.register("dashboard-layout", DashboardLayoutController)
application.register("expense-deck", ExpenseDeckController)
application.register("welcome-celebration", WelcomeCelebrationController)
application.register("welcome-grow", WelcomeGrowController)
application.register("web-sidebar", WebSidebarController)
application.register("web-add", WebAddController)
application.register("web-drag-scroll", WebDragScrollController)
application.register("web-page-actions", WebPageActionsController)
application.register("plaid-row", PlaidRowController)
application.register("plaid-sync-all", PlaidSyncAllController)
application.register("whats-new-tuner", WhatsNewTunerController)
application.register("feature-tour", FeatureTourController)
application.register("about-page", AboutPageController)

